import { Menu, Stack, Tab, Tabs } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';
import { Colors } from 'libs/ui/theme';

import { MenuBurgerPressedStyled } from './OverflowTabs.styles';
import { OverflowTabsProps } from './types';
import { useOverflowTabs } from './useOverflowTabs';

export const OverflowTabs = ({ tabs, ...tabsProps }: OverflowTabsProps) => {
  const {
    containerRef,
    visibleTabs,
    overflowTabs,
    anchorEl,
    isMenuOpen,
    handleCloseMenu,
    onClickMenuOption,
    onBurgerEvent,
  } = useOverflowTabs({ tabs, ...tabsProps });

  return (
    <>
      <Stack
        ref={containerRef}
        alignItems="center"
        direction="row"
        spacing={32}
      >
        <Tabs {...tabsProps} variant="fullWidth">
          {visibleTabs.map((tab) => (
            <Tab key={tab.value} {...tab} />
          ))}
        </Tabs>
        {overflowTabs.length > 0 && (
          <MenuBurgerPressedStyled
            datax="tabs-menu-button"
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                onBurgerEvent(event);
              }
            }}
            onMouseOver={onBurgerEvent}
          >
            <Icon.MenuBurger
              className="overflowTabs-burger"
              color={
                overflowTabs.find((tab) => tab.isError) ? Colors.red : undefined
              }
              size={16}
            />
          </MenuBurgerPressedStyled>
        )}
      </Stack>
      <Menu
        anchorEl={anchorEl}
        open={isMenuOpen}
        options={overflowTabs.map((tab) => ({
          value: tab.value,
          label: tab.label,
          color: tab.isError ? Colors.red : undefined,
          isValueLink: Boolean(tab.href),
          isActive: tabsProps.value === tab.value,
        }))}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClickOption={onClickMenuOption}
        onClose={handleCloseMenu}
        onMouseLeave={handleCloseMenu}
      />
    </>
  );
};
